import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import * as Styled from "./TableRow.styled";
export const TableRow = forwardRef(({ children, shouldHighlightOnHover, isHighlighted, isHeader, ...otherProps }, ref) => (_jsx(Styled.TableRow, { ref: ref, palette: "interactiveConstructive", shouldHighlightOnHover: shouldHighlightOnHover, isHighlighted: isHighlighted, isHeader: isHeader, ...otherProps, children: children })));
TableRow.displayName = "TableRow";
